import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API_CONFIG } from "src/config/api.config";
import { Produto, ProdutoConsulta } from "../classes/produto";
import { AuthService } from "./auth.service";

@Injectable({
    providedIn: 'root'
})

export class ProdutoService {
    apriUrl = `${API_CONFIG.baseUrl}/produto`;
    postId;
    putId;

    token = this.storage.getLocalUser().token;
    authHeader = new HttpHeaders({'Authorization':'Bearer ' + this.storage.getLocalUser().token});

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(
        private httpClient: HttpClient,
        private storage: AuthService
    ) { }

    public getProdutos(): Observable<Produto[]> {
        return this.httpClient.get<Produto[]>(this.apriUrl, {'headers': this.authHeader});
    }

    public getProdutoById(ident: any): Observable<any[]> {
        return this.httpClient.get<any[]>(this.apriUrl+'/'+ ident, {'headers': this.authHeader});
    }

    public getProdutoByIdConsulta(ident: any): Observable<ProdutoConsulta> {
        return this.httpClient.get<ProdutoConsulta>(this.apriUrl+'/'+ ident, {'headers': this.authHeader});
    }
    
    public getCategoriasProduto(ident: any): Observable<Produto[]> {
        return this.httpClient.get<Produto[]>(this.apriUrl + '/' + ident, {'headers': this.authHeader});
    }

    public postProduto(produto: any){
        return this.httpClient.post<any>(this.apriUrl, produto, {'headers': this.authHeader});
    }

    public putProduto(produto: any, ident: any): Observable<any[]> {
        return this.httpClient.put<any>(this.apriUrl +'/'+ ident, produto, {'headers': this.authHeader});
    }

    public async deleteProduto(ident: any){
        return this.httpClient.delete<any>(this.apriUrl +'/'+ ident, {'headers': this.authHeader}).subscribe(
            data =>{this.putId = data.id;}
        );
    }
}